interface IProfileCreationOrganization {
    details?: {
        configuration?: {
            allowEmptyEmailAddressDuringUserCreation?: boolean;
        };
    };
}

export const isNoEmailProfileCreationEnabled = (
    organization?: IProfileCreationOrganization,
    onlyDataFromForm?: boolean
): boolean =>
    !onlyDataFromForm
    && organization?.details?.configuration?.allowEmptyEmailAddressDuringUserCreation === true;
